import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "become-dealer-header text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "page-title-custom" }, "Sede principale", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("label", null, " Marlù Gioielli "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Via M. Bucci, 55 - 47895, Domagnano (RSM) "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Email: info@marlu.it - Tel: 0549-907220 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" COE: SM 22394 ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sep short" }, null, -1)
const _hoisted_5 = { class: "page-title-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("h3", _hoisted_5, [
      _renderSlot(_ctx.$slots, "title")
    ])
  ]))
}